<!-- Form row -->
<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row align-items-end" *ngIf="loaded && !casoCerrado && !disableOptions">
          <div class="col-md-12 mb-3">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="altaArbitroCheckbox" [(ngModel)]="altaArbitro"
                name="altaArbitro" (change)="toggleAltaArbitro()">
              <label class="form-check-label" for="altaArbitroCheckbox" i18n>
                No encuentro al árbitro en el listado, quiero darle de alta.
              </label>
            </div>
          </div>
        </div>

        <!-- Formulario asignación de árbitro-->
        <div *ngIf="!altaArbitro">
          <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate *ngIf="loaded && !casoCerrado && !disableOptions">
            <div class="row align-items-end">
              <!-- Usuario -->
              <div class="col-md-8 mb-3">
                <label for="selectUsuario" class="form-label" i18n>Árbitros (*)</label>
                <select2 [data]="usuarios" id="selectUsuario" name="id_usuario" #id_usuario="ngModel"
                  [(ngModel)]="model.id_usuario" multiple="false" displaySearchStatus="always" noLabelTemplate="true"
                  [disabled]="casoCerrado"
                  [ngClass]="{ 'is-invalid': (id_usuario.invalid && f.submitted) || (id_usuario.invalid && (id_usuario.dirty || id_usuario.touched))}">
                </select2>
              </div>
            </div>

            <div class="row align-items-end">
              <!-- Tipo -->
              <div class="col-md-3 mb-3">
                <label for="selectTipo" class="form-label" i18n>Tipo (*)</label>
                <select class="form-select" id="selectTipo" name="tipo" #tipo="ngModel" [(ngModel)]="model.tipo"
                  required [disabled]="casoCerrado"
                  [ngClass]="{ 'is-invalid': (tipo.invalid && f.submitted) || (tipo.invalid && (tipo.dirty || tipo.touched))}">
                  <option value="" disabled selected i18n>Seleccione</option>
                  <option value="TRIBUNAL" i18n>TRIBUNAL</option>
                  <option value="SECRETARIO_ADMINISTRATIVO" i18n>SECRETARIO ADMINISTRATIVO</option>
                  <option value="EQUIPO_TRIBUNAL" i18n>EQUIPO TRIBUNAL</option>
                </select>
              </div>

              <!-- Fecha de Designación -->
              <div class="col-md-3 mb-3">
                <label for="inputFechaDesignacion" class="form-label" i18n>Fecha de Designación (*)</label>
                <input type="date" class="form-control" id="inputFechaDesignacion" name="fecha_designacion"
                  #fecha_designacion="ngModel" [(ngModel)]="model.fecha_designacion" required [disabled]="casoCerrado"
                  [ngClass]="{ 'is-invalid': (fecha_designacion.invalid && f.submitted) || (fecha_designacion.invalid && (fecha_designacion.dirty || fecha_designacion.touched))}">
              </div>

              <div class="col-md-3 mb-3"
                *ngIf="model.tipo !== 'SECRETARIO_ADMINISTRATIVO' && model.tipo !== 'EQUIPO_TRIBUNAL'">
                <label for="selectArbitroRol" class="form-label" i18n>Rol del Árbitro (*)</label>
                <select class="form-select" id="selectArbitroRol" name="arbitro_rol" #arbitro_rol="ngModel"
                  [(ngModel)]="model.arbitro_rol"
                  [required]="model.tipo !== 'SECRETARIO_ADMINISTRATIVO' && model.tipo !== 'EQUIPO_TRIBUNAL'"
                  [disabled]="casoCerrado"
                  [ngClass]="{ 'is-invalid': (arbitro_rol.invalid && f.submitted) || (arbitro_rol.invalid && (arbitro_rol.dirty || arbitro_rol.touched))}">
                  <option value="" disabled selected i18n>Seleccione</option>
                  <option value="PRESIDENTE" i18n>PRESIDENTE</option>
                  <option value="COARBITRO_1" i18n>CO-ÁRBITRO DEMANDANTE</option>
                  <option value="COARBITRO_2" i18n>CO-ÁRBITRO DEMANDADO</option>
                  <option value="ARBITRO_UNICO" i18n>ÁRBITRO ÚNICO</option>
                  <option value="ARBITRO_EMERGENCIA" i18n>ÁRBITRO DE EMERGENCIA</option>
                </select>
              </div>

              <div class="col-md-3 mb-3"
                *ngIf="model.tipo !== 'SECRETARIO_ADMINISTRATIVO' && model.tipo !== 'EQUIPO_TRIBUNAL'">
                <label for="selectArbitroSistemaDesignacion" class="form-label" i18n>Sistema de Designación (*)</label>
                <select class="form-select" id="selectArbitroSistemaDesignacion" name="arbitro_sistema_designacion"
                  #arbitro_sistema_designacion="ngModel" [(ngModel)]="model.arbitro_sistema_designacion"
                  [disabled]="casoCerrado"
                  [required]="model.tipo !== 'SECRETARIO_ADMINISTRATIVO' && model.tipo !== 'EQUIPO_TRIBUNAL'"
                  [ngClass]="{ 'is-invalid': (arbitro_sistema_designacion.invalid && f.submitted) || (arbitro_sistema_designacion.invalid && (arbitro_sistema_designacion.dirty || arbitro_sistema_designacion.touched))}">
                  <option value="" disabled selected i18n>Seleccione</option>
                  <option value="PARTES" i18n>PARTES</option>
                  <option value="COARBITROS" i18n>CO-ÁRBITROS</option>
                  <option value="DESIGNACION_DIRECTA" i18n>DESIGNACIÓN DIRECTA</option>
                  <option value="DESIGNACION_LISTA" i18n>DESIGNACIÓN LISTA</option>
                </select>
              </div>

              <div class="col-md-6 mb-3"
                *ngIf="model.tipo == 'SECRETARIO_ADMINISTRATIVO' || model.tipo == 'EQUIPO_TRIBUNAL'"></div>
            </div>

            <div class="row align-items-end">

              <div class="col-md-4 mb-2">
                <label class="form-label d-block" i18n>Enviar al árbitro email de asociación al caso (*)</label>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="enviar_email_asociacion" id="emailAsociacionSi"
                    value="true" [(ngModel)]="model.enviar_email_asociacion" required>
                  <label class="form-check-label" for="emailAsociacionSi" i18n>Sí</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="enviar_email_asociacion" id="emailAsociacionNo"
                    value="false" [(ngModel)]="model.enviar_email_asociacion" required>
                  <label class="form-check-label" for="emailAsociacionNo" i18n>No</label>
                </div>
              </div>

              <div class="col-md-8 text-end mb-2 d-flex justify-content-end">
                <button type="submit" class="btn btn-primary waves-effect waves-light"
                  [disabled]="f.invalid || !model.id_usuario || casoCerrado || disableOptions">
                  <span i18n>Asociar al caso</span>
                </button>
              </div>

            </div>
          </form>
        </div>

        <!-- Formulario de alta de árbitro -->
        <div *ngIf="altaArbitro">
          <form #altaForm="ngForm" (ngSubmit)="onRegistrarArbitro(altaForm)" novalidate
            *ngIf="loaded && !casoCerrado && !disableOptions">
            <div class="row align-items-end">
              <!-- Nombre -->
              <div class="col-md-3 mb-3">
                <label for="inputNombre" class="form-label" i18n>Nombre (*)</label>
                <input type="text" class="form-control" id="inputNombre" name="nombre" [(ngModel)]="nuevoArbitro.nombre"
                  #nombre="ngModel" required [disabled]="casoCerrado"
                  [ngClass]="{ 'is-invalid': (nombre.invalid && altaForm.submitted) || (nombre.invalid && (nombre.dirty || nombre.touched))}">
                <!--
                <div
                  *ngIf="(nombre.invalid && altaForm.submitted) || (nombre.invalid && (nombre.dirty || nombre.touched))">
                  <p class="validator-message" i18n>Campo obligatorio</p>
                </div>
                -->
              </div>

              <!-- Apellidos -->
              <div class="col-md-3 mb-3">
                <label for="inputApellidos" class="form-label" i18n>Apellidos (*)</label>
                <input type="text" class="form-control" id="inputApellidos" name="apellidos"
                  [(ngModel)]="nuevoArbitro.apellidos" #apellidos="ngModel" required [disabled]="casoCerrado"
                  [ngClass]="{ 'is-invalid': (apellidos.invalid && altaForm.submitted) || (apellidos.invalid && (apellidos.dirty || apellidos.touched))}">
                <!--
                <div
                  *ngIf="(apellidos.invalid && altaForm.submitted) || (apellidos.invalid && (apellidos.dirty || apellidos.touched))">
                  <p class="validator-message" i18n>Campo obligatorio</p>
                </div>
              -->
              </div>

              <!-- Correo electrónico -->
              <div class="col-md-4 mb-3">
                <label for="inputEmail" class="form-label"><span i18n>Correo electrónico (*)</span>
                  <span *ngIf="emailExiste" class="text-danger" i18n> El email ya existe</span>
                </label>
                <input type="email" class="form-control" id="inputEmail" name="email" [(ngModel)]="nuevoArbitro.email"
                  #email="ngModel" required email [disabled]="casoCerrado"
                  (blur)="onEmailBlur(nuevoArbitro.email ?? '')"
                  [ngClass]="{ 'is-invalid': (email.invalid && altaForm.submitted) || emailExiste || (email.invalid && (email.dirty || email.touched)) }">
                <!--
                <div *ngIf="(email.invalid && altaForm.submitted) || (email.invalid && (email.dirty || email.touched))">
                  <p class="validator-message" i18n>Introduzca una dirección de email válida</p>
                </div>
                -->
              </div>

              <div class="col-md-2 mb-3"></div>

              <!-- Tipo -->
              <div class="col-md-3 mb-3">
                <label for="selectTipo" class="form-label" i18n>Tipo (*)</label>
                <select class="form-select" id="selectTipo" name="tipo" #tipo="ngModel" [(ngModel)]="nuevoArbitro.tipo"
                  required [disabled]="casoCerrado"
                  [ngClass]="{ 'is-invalid': (tipo.invalid && altaForm.submitted) || (tipo.invalid && (tipo.dirty || tipo.touched))}">
                  <option value="" disabled selected i18n>Seleccione</option>
                  <option value="TRIBUNAL" i18n>TRIBUNAL</option>
                  <option value="SECRETARIO_ADMINISTRATIVO" i18n>SECRETARIO ADMINISTRATIVO</option>
                  <option value="EQUIPO_TRIBUNAL" i18n>EQUIPO TRIBUNAL</option>
                </select>
              </div>

              <!-- Fecha de Designación -->
              <div class="col-md-3 mb-3">
                <label for="inputFechaDesignacion" class="form-label" i18n>Fecha de Designación (*)</label>
                <input type="date" class="form-control" id="inputFechaDesignacion" name="fecha_designacion"
                  #fecha_designacion="ngModel" [(ngModel)]="nuevoArbitro.fecha_designacion" required
                  [disabled]="casoCerrado"
                  [ngClass]="{ 'is-invalid': (fecha_designacion.invalid && altaForm.submitted) || (fecha_designacion.invalid && (fecha_designacion.dirty || fecha_designacion.touched))}">
              </div>

              <!-- Rol -->
              <div class="col-md-3 mb-3" *ngIf="nuevoArbitro.tipo !== 'SECRETARIO_ADMINISTRATIVO'">
                <label for="selectArbitroRol" class="form-label" i18n>Rol del Árbitro (*)</label>
                <select class="form-select" id="selectArbitroRol" name="arbitro_rol" #arbitro_rol="ngModel"
                  [(ngModel)]="nuevoArbitro.arbitro_rol"
                  [required]="nuevoArbitro.tipo !== 'SECRETARIO_ADMINISTRATIVO' && nuevoArbitro.tipo !== 'EQUIPO_TRIBUNAL'"
                  [disabled]="casoCerrado"
                  [ngClass]="{ 'is-invalid': (arbitro_rol.invalid && altaForm.submitted) || (arbitro_rol.invalid && (arbitro_rol.dirty || arbitro_rol.touched))}">
                  <option value="" disabled selected i18n>Seleccione</option>
                  <option value="PRESIDENTE" i18n>PRESIDENTE</option>
                  <option value="COARBITRO_1" i18n>CO-ÁRBITRO DEMANDANTE</option>
                  <option value="COARBITRO_2" i18n>CO-ÁRBITRO DEMANDADO</option>
                  <option value="ARBITRO_UNICO" i18n>ÁRBITRO ÚNICO</option>
                  <option value="ARBITRO_EMERGENCIA" i18n>ÁRBITRO DE EMERGENCIA</option>
                </select>
              </div>

              <!-- Sistema de designación -->
              <div class="col-md-3 mb-3"
                *ngIf="nuevoArbitro.tipo !== 'SECRETARIO_ADMINISTRATIVO' && nuevoArbitro.tipo !== 'EQUIPO_TRIBUNAL'">
                <label for="selectArbitroSistemaDesignacion" class="form-label" i18n>Sistema de Designación (*)</label>
                <select class="form-select" id="selectArbitroSistemaDesignacion" name="arbitro_sistema_designacion"
                  #arbitro_sistema_designacion="ngModel" [(ngModel)]="nuevoArbitro.arbitro_sistema_designacion"
                  [disabled]="casoCerrado"
                  [required]="nuevoArbitro.tipo !== 'SECRETARIO_ADMINISTRATIVO' && nuevoArbitro.tipo !== 'EQUIPO_TRIBUNAL'"
                  [ngClass]="{ 'is-invalid': (arbitro_sistema_designacion.invalid && altaForm.submitted) || (arbitro_sistema_designacion.invalid && (arbitro_sistema_designacion.dirty || arbitro_sistema_designacion.touched))}">
                  <option value="" disabled selected i18n>Seleccione</option>
                  <option value="PARTES" i18n>PARTES</option>
                  <option value="COARBITROS" i18n>CO-ÁRBITROS</option>
                  <option value="DESIGNACION_DIRECTA" i18n>DESIGNACIÓN DIRECTA</option>
                  <option value="DESIGNACION_LISTA" i18n>DESIGNACIÓN LISTA</option>
                </select>
              </div>
            </div>

            <div class="row align-items-end">
              <!-- Preguntas de control -->
              <div class="col-md-4 mb-2">
                <label class="form-label d-block" i18n>Enviar al árbitro email de asociación al caso (*)</label>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="enviar_email_asociacion" id="emailAsociacionSi"
                    value="true" [(ngModel)]="nuevoArbitro.enviar_email_asociacion" required>
                  <label class="form-check-label" for="emailAsociacionSi" i18n>Sí</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="enviar_email_asociacion" id="emailAsociacionNo"
                    value="false" [(ngModel)]="nuevoArbitro.enviar_email_asociacion" required>
                  <label class="form-check-label" for="emailAsociacionNo" i18n>No</label>
                </div>
              </div>

              <div class="col-md-4 mb-2">
                <label class="form-label d-block" i18n>Enviar al árbitro email de bienvenida (*)</label>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="enviar_email_validacion" id="emailBienvenidaSi"
                    value="true" [(ngModel)]="nuevoArbitro.enviar_email_validacion" required>
                  <label class="form-check-label" for="emailBienvenidaSi" i18n>Sí</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="enviar_email_validacion" id="emailBienvenidaNo"
                    value="false" [(ngModel)]="nuevoArbitro.enviar_email_validacion" required>
                  <label class="form-check-label" for="emailBienvenidaNo" i18n>No</label>
                </div>
              </div>

              <div class="col-md-4 text-end mb-2 d-flex justify-content-end">
                <button type="submit" class="btn btn-primary waves-effect waves-light"
                  [disabled]="altaForm.invalid || casoCerrado || disableOptions || emailExiste || validatingEmail"><span
                    i18n>Registrar árbitro y
                    asociar al caso</span></button>
              </div>
            </div>
          </form>
        </div>

        <div class="position-relative mt-3"> <!-- Ajustado para reducir el margen superior -->
          <div id="status" class="spinner-container" *ngIf="isLoading">
            <div class="spinner">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>


          <div class="row mt-4" *ngIf="tribunalesLoaded && tribunalesList.length > 0; else noTribunales">
            <div class="col-md-4" *ngFor="let tribunal of tribunalesList">
              <div class="card tribunal-card position-relative"
                [ngClass]="{'opacity-50': tribunal.estado === 'SUSTITUIDO'}">
                <!-- Marca de agua "SUSTITUIDO" -->
                <div *ngIf="tribunal.estado === 'SUSTITUIDO'" class="watermark">SUSTITUIDO</div>
                <div class="card-body">
                  <div class="d-flex flex-row">
                    <img *ngIf="avatarUrls[tribunal.id_usuario!]" [src]="avatarUrls[tribunal.id_usuario!]"
                      class="rounded-circle" style="width: 65px; height: 65px; object-fit: cover;">
                    <div class="ms-3 flex-grow-1">
                      <h5>{{ tribunal.nombre }} {{ tribunal.apellidos }}</h5>
                      <p *ngIf="tribunal['usuario'] && !tribunal['usuario']['validado']" class="text-danger small">
                        Usuario no validado</p>
                      <p>{{ convertirArbitroRol(tribunal.arbitro_rol, cuantiaReconvencion) || convertirArbitroTipo(tribunal.tipo) }}</p>
                      <p *ngIf="tribunal.tipo !== 'SECRETARIO_ADMINISTRATIVO' && tribunal.tipo !== 'EQUIPO_TRIBUNAL'">
                        <span i18n>Sistema de Designación</span> <br>{{
                        this.convertirSistemasDesignacion(tribunal.arbitro_sistema_designacion) }}
                      </p>
                      <p><span i18n>Fecha de Designación</span> <br>{{ tribunal.fecha_designacion_formateada }}</p>
                    </div>
                    <div class="position-absolute top-0 end-0 d-flex align-items-center"
                      style="margin-top: 8px; margin-right: 8px;">
                      <button type="button" class="btn btn-link p-0 me-2"
                        (click)="!casoCerrado && markAsSustituido(tribunal.id)"
                        [disabled]="casoCerrado || disableOptions" *ngIf="tribunal.estado !== 'SUSTITUIDO'">
                        <i class="fa fa-exchange-alt"></i>
                      </button>
                      <button type="button" class="btn btn-link p-0"
                        (click)="!casoCerrado && openDeleteModal(tribunal)"
                        [disabled]="casoCerrado || disableOptions">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </div>
                  <!-- Switch de notificaciones -->
                  <div class="form-check form-switch d-flex align-items-center w-100 mt-3">
                    <input type="checkbox" [id]="'switch_' + tribunal.id" class="form-check-input me-2"
                      name="enviar_email_subida_archivo" [checked]="tribunal.enviar_email_subida_archivo"
                      (change)="onSwitchChange(tribunal.id)" [disabled]="casoCerrado || disableOptions">
                    <label for="'switch_' + tribunal.id" class="form-check-label mt-0" i18n>Aviso de nuevos
                      documentos</label>
                  </div>
                  <div class="form-check form-switch d-flex align-items-center w-100 mt-3">
                    <input type="checkbox" [id]="'switchHito_' + tribunal.id" class="form-check-input me-2"
                      name="enviar_email_hito" [checked]="tribunal.enviar_email_hito"
                      (change)="onSwitchChangeHitos(tribunal.id)" [disabled]="casoCerrado || disableOptions">
                    <label for="'switch_' + tribunal.id" class="form-check-label mt-0" i18n>Aviso de próximos
                      vencimientos</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ng-template #noTribunales>
            <p *ngIf="tribunalesLoaded" i18n>No se ha encontrado ningún Tribunal</p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal para confirmar borrado -->
<div class="confirm-delete-modal" *ngIf="showConfirmDeleteModal">
  <div class="confirm-delete-modal-content">
    <div class="confirm-delete-modal-header">
      <h5 class="confirm-delete-modal-title" i18n>Confirmar Borrado</h5>
    </div>
    <div class="confirm-delete-modal-body">
      <p><span i18n>¿Estás seguro de que deseas borrar a</span> "{{ tribunalToDelete?.nombre }} {{ tribunalToDelete?.apellidos }}"?</p>
    </div>
    <div class="confirm-delete-modal-footer">
      <button type="button" class="btn btn-danger waves-effect waves-light" style="margin-right: 20px;"
        (click)="confirmDelete()">
        <span class="btn-label"><i class="fe-trash"></i></span><span i18n>Borrar</span>
      </button>
      <button type="button" class="btn btn-secondary waves-effect waves-light" (click)="closeDeleteModal()">
        <span class="btn-label"><i class="fe-x"></i></span><span i18n>Cancelar</span>
      </button>
    </div>
  </div>
</div>
